import ProtectedRoute from "../ProtectedRoute";
import { Role, routerRoles } from "../Router";
import { Layout } from "@/components";
import { Navigate } from "react-router-dom";
import { Dashboard, AccessMgmt } from "@/pages";
import { routes } from "../utils";
import { MasterDataRoutes } from "./MasterDataRoutes";
import { ActivityDashboardRoutes } from "./ActivityDashboardRoutes";
import { IncidentMgmtRoutes } from "./IncidentMgmtRoutes";
import { AdminConsoleRoutes } from "./AdminConsoleRoutes";

const AdminRoutes = () => ({
  // Only admins allowed
  path: routes.admin,
  element: <ProtectedRoute allowedRoles={[routerRoles.admin as Role]} />,
  children: [
    {
      path: "",
      element: <Layout />,
      children: [
        {
          path: "",
          element: (
            <Navigate to={`/${routes.admin}/${routes.activityDashboard}`} />
          ),
        },
        {
          path: routes.dashboard,
          element: <Dashboard />,
        },
        AdminConsoleRoutes(),
        MasterDataRoutes(),
        ActivityDashboardRoutes(),
        {
          path: routes.accessMgmt,
          element: <AccessMgmt />,
        },
        IncidentMgmtRoutes(),
      ],
    },
  ],
});

export default AdminRoutes;
